/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', () => {
    const obflink = document.querySelectorAll('span[data-obflink]');
    obflink.forEach((link) => {
      link.addEventListener('click', (event) => {
        const encoded_link = link.dataset.obflink;
        const decoded_link = decodeURIComponent(escape(window.atob(encoded_link)));
        if (event.ctrlKey) {
          const newWindow = window.open(decoded_link, '_blank');
          if (newWindow) newWindow.focus();
        } else {
          window.location.href = decoded_link;
        }
      });
    });
  });


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
